/**
 * Indices into MediaPipe's 478-point face mesh.
 *
 * These are the only points we need to place a pair of glasses: an anchor on
 * the bridge, a width measurement, two more to build an orientation basis, and
 * the eye corners and nose tip that face-metrics measures the wearer with.
 */
export const LANDMARK = {
  /** Bridge of the nose, just below the brow line — where glasses actually rest. */
  NOSE_BRIDGE: 168,
  /** Tip of the nose. Paired with the bridge to gauge how much the nose juts out. */
  NOSE_TIP: 1,
  /** Outer edge of the face on the viewer's left, at roughly temple height. */
  FACE_LEFT: 234,
  /** Outer edge of the face on the viewer's right. */
  FACE_RIGHT: 454,
  /** Centre of the forehead at the hairline. */
  FOREHEAD: 10,
  /** Bottom of the chin. */
  CHIN: 152,
  /** Eye corners. Each inner/outer pair averages to that eye's centre. */
  LEFT_EYE_INNER: 133,
  LEFT_EYE_OUTER: 33,
  RIGHT_EYE_INNER: 362,
  RIGHT_EYE_OUTER: 263,
  /** Iris centres — used to estimate pupillary distance. */
  LEFT_IRIS: 468,
  RIGHT_IRIS: 473,
};

/** Total landmarks the Face Landmarker returns (468 mesh + 10 iris). */
export const LANDMARK_COUNT = 478;
